<template>
  <!--
      作者：zhuchangtao
      时间：2020-12-12
      描述：插件中心-抽奖活动
    -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="抽奖管理" name="sweepstakes"></el-tab-pane>

      <el-tab-pane label="抽奖设置" name="setting"></el-tab-pane>
    </el-tabs>
    <!--抽奖管理-->
    <Sweepstakes v-if="activeName == 'sweepstakes'"></Sweepstakes>



  </div>
</template>
<script>
import Sweepstakes from './sweepstakes/index.vue';


export default {
  components: {
    Sweepstakes,

  },
  data() {
    return {

      /*当前选中*/
      activeName: 'sweepstakes'
    };
  },
  created() {
    /*获取列表*/


    // localStorage.setItem('activeName',this.activeName)

    let active_name = localStorage.getItem('activeName')


    if(active_name){
      this.activeName = active_name
      localStorage.clear()
    }
  },
  methods: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/index.vue